module.exports = __webpack_public_path__ + "static/media/gram-big.461a6d68.jpg";